import("babel-polyfill");
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/style.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import SlideVerify from './components/lib/index';
import cnzzAnalytics from 'vue-cnzz-analytics'
import * as echarts from 'echarts';
import VueLazyload from 'vue-lazyload'

// 引入公共js
import common from "./common/common.js";
Vue.prototype.common = common;
// api
import api from "./api";

Vue.config.productionTip = false;
Vue.prototype.$api = api;

Vue.use(VueLazyload)
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeSwiper);
Vue.use(SlideVerify);
api.common().then((res) => {
	if(res.data.help.copyright.statistics_url){
		Vue.use(cnzzAnalytics, {
		  router: router,
		  siteIdList: [
		    1279666948
		  ],
		  isDebug: false
		});
	}
}).catch((err) => {
	console.log(err)
});


router.afterEach((to, from, next) => {
	window.scrollTo(0, 0)
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
